<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in tabList"
          :key="$index"
          v-permissson="`${item.permissson}`"
          class="tabItem"
          :class="{ activeName: activeName === $index }"
          @click="handleClick($index, item.permissson)"
        >{{ item.name }}
        </span>
      </div>
      <div class="opt">
        <div style="display: flex">
          <div class="btn flex_c_c" @click="dialogFormVisible = true">
            <img src="@/assets/images/order/add.png" />
            新增
          </div>
          <div v-permissson="'derive'" class="btn flex_c_c" @click="derive">
            <img src="@/assets/images/const/derive.png" alt="导出" />
            导出
          </div>
          <BaseFilter
            :isActive="isActive"
            :width="466"
            @sendFilter="sendFilter"
            @reset="reset"
          >
            <div class="filter">
              <el-form ref="form" :model="filterList" label-width="70px">
                <el-form-item label="搜索">
                  <el-input
                    v-model="filterList.search"
                    placeholder="请输入代码/中文名称/简称"
                    style="width: 320px"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="activeName === 1" label="销售员">
                  <el-select
                    v-model="filterList.saleId"
                    filterable
                    clearable
                    style="width: 320px"
                    placeholder="请选择销售员"
                  >
                    <el-option
                      v-for="item in userOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="activeName === 1" label="客户">
                  <el-select
                    v-model="filterList.companyId"
                    style="width: 320px"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in companyDrapdown"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="activeName === 1" label="状态">
                  <el-select
                    v-model="filterList.isActived"
                    style="width: 320px"
                    clearable
                    placeholder="请选择状态"
                  >
                    <el-option
                      v-for="item in activeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
          </BaseFilter>
        </div>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="{
          ...tableData1,
          fileds,
        }"
        :pageIndex="pagerConfig.pageIndex"
        :pageSize="pagerConfig.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="nameCH" slot-scope="row">
          {{ row.scope.nameCH }}
          <p class="sub">
            {{ row.scope.parentCompanyNmae }}
          </p>
        </template>
        <template slot="isActived" slot-scope="row">
          <div
            class="circle"
            :style="{
              'background-color': row.scope.isActived ? ' #35BA83' : '#FE453D',
            }"
          ></div>
          {{ row.scope.isActived ? "使用中" : "未使用" }}
        </template>
        <template slot="yy" slot-scope="row">
          <img src="@/assets/images/system/license.png" class="license" />
          <el-button
            type="text"
            size="mini"
            @click="viewImg(row.scope, 1)"
          >查看</el-button
          >
        </template>
        <template slot="address" slot-scope="row">
          <svg-icon
            style="vertical-align: -8px"
            iconClass="address"
            className="icon"
          />
          <el-tooltip
            class="item"
            effect="dark"
            :tabindex="2000"
            placement="bottom"
          >
            <div slot="content">
              {{
                `${row.scope.countryId}/${row.scope.provinceId}/${row.scope.cityId}`
                  | formatterAddress
              }}{{ row.scope.address }}
            </div>
            <el-button type="text" size="mini">查看</el-button>
          </el-tooltip>
        </template>
        <template slot="remark" slot-scope="row">
          <svg-icon
            style="vertical-align: -8px"
            iconClass="remark"
            className="icon"
          />
          <el-tooltip
            class="item"
            effect="dark"
            :tabindex="2000"
            :content="row.scope.remark"
            placement="bottom"
          >
            <el-button type="text" size="mini">查看</el-button>
          </el-tooltip>
        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-show="computedPermissions('修改')"
                  :v-permissson="computedPermissions('修改')"
                  class="opt-item"
                  @click="updateRow(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-show="computedPermissions('查看成员')"
                  :v-permissson="computedPermissions('查看成员')"
                  class="opt-item"
                  @click="viewMember(row.scope)"
                >查看成员</el-button
                >
                <el-button
                  v-show="computedPermissions('查看子公司')"
                  v-if="!row.scope.parentCompanyId"
                  :v-permissson="computedPermissions('查看子公司')"
                  class="opt-item"
                  @click="viewSub(row.scope)"
                >查看子公司</el-button
                >
                <el-button
                  v-show="computedPermissions('审核通过')"
                  v-if="!activeName && !row.scope.applyStatus"
                  :v-permissson="computedPermissions('审核通过')"
                  class="opt-item"
                  @click="updateRow(row.scope)"
                >审核通过</el-button
                >
                <el-button
                  v-show="computedPermissions('审核拒绝')"
                  v-if="!activeName && !row.scope.applyStatus"
                  :v-permissson="computedPermissions('审核拒绝')"
                  class="opt-item"
                  @click="refuse(row.scope)"
                >审核拒绝</el-button
                >
                <el-button
                  v-show="computedPermissions('停用启用')"
                  :v-permissson="computedPermissions('停用启用')"
                  class="opt-item"
                  @click="
                    () => {
                      changeStatus(!row.scope.isActived, row.scope);
                    }
                  "
                >{{ !row.scope.isActived ? "启用" : "停用" }}</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
      </BaseTable>
    </div>
    <approved-company-dialog
      :dialogVisible="dialogFormVisible"
      :editData="editData"
      :userOptions="userOptions"
      :callType="callType"
      @ok="ok"
      @cancel="cancel"
    >
    </approved-company-dialog>
    <bill-account-dialog
      :dialogVisible="dialogFormVisible1"
      :companyId="editData.id"
      @ok="ok2"
      @cancel="cancel2"
    >
    </bill-account-dialog>
    <RefuseReasonDialog
      :dialogVisible="dialogFormVisible2"
      @ok="ok3"
      @cancel="dialogFormVisible2 = false"
    >
    </RefuseReasonDialog>
    <el-dialog
      v-drag
      title="查看营业执照"
      :visible.sync="dialogVisible2"
      :append-to-body="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="() => (dialogVisible2 = false)"
      width="858px"
      center
    >
      <div class="imgbox">
        <img :src="certificateFileUrl" />
      </div>
    </el-dialog>
    <PriceSetDrawer
      :drawer="drawer"
      :rowData="editData"
      :tplType="0"
      @close="drawer = false; editData = {}"
    />
    <ViewSubCompany
      :rowData="editData"
      :userOptions="userOptions"
      :dialogVisible="dialogVisible3"
      @cancel="dialogVisible3 = false; editData = {}">
    </ViewSubCompany>
    <ViewMemberDialog
      :dialogVisible="dialogVisible4"
      :rowData="editData"
      @ok="ok"
      @cancel="dialogVisible4 = false; editData = {}">
    </ViewMemberDialog>
  </div>
</template>

<script>
let that
const BaseTable = () => import('@/components/table/BaseTable')
import {
  getCompanyPages,
  enableOrDisableCompany,
  getUserForType,
  getApplyRecordPageList,
  refuseCompany
  // reject
} from '@/api/system'
import { mapGetters } from 'vuex'
import { derive } from '@/utils/common'
import ApprovedCompanyDialog from './components/ApprovedCompanyDialog.vue'
import BillAccountDialog from './components/BillAccountDialog.vue'
import RefuseReasonDialog from './components/RefuseReasonDialog.vue'
import ViewSubCompany from './components/ViewSubCompany.vue'
import ViewMemberDialog from './components/ViewMemberDialog.vue'

import config from '@/utils/config'
const BaseFilter = () => import('@/components/filter/BaseFilter')
const PriceSetDrawer = () => import('@/components/drawer/PriceSetDrawer')
import { permissions } from '@/utils/common'
import { myMixins } from '@/mixins'
export default {
  name: 'Company',
  components: {
    BaseTable,
    ApprovedCompanyDialog,
    BaseFilter,
    BillAccountDialog,
    RefuseReasonDialog,
    PriceSetDrawer,
    ViewSubCompany,
    ViewMemberDialog
  },
  filters: {
    formatterAddress(val) {
      const arr = val.split('/')
      const country =
        that.addressDropOption &&
        that.addressDropOption.find((a) => a.value === parseInt(arr[0], 10))
      const province =
        country &&
        country.children.find((a) => a.value === parseInt(arr[1], 10))
      const city =
        province &&
        province.children.find((a) => a.value === parseInt(arr[2], 10))
      let addressStr = ''
      if (country && province && city) {
        addressStr = `${country.label}${province.label}${city.label}`
      }
      return addressStr
    }
  },
  mixins: [myMixins],
  data() {
    return {
      config,
      tabList: [
        { name: '待确认', permissson: 'DQR', type: 0 },
        { name: '已确认', permissson: 'YQR', type: 1 }
      ],
      pagerConfig: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      tableData1: {
        fileds: [],
        columns: [],
        total: 0
      },
      height: 0,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      drawer: false,
      editData: {},
      filterList: {
        search: '',
        isActived: '',
        areaValue: '',
        companyId: '',
        saleId: ''
      },
      isActive: false,
      activeOption: [
        {
          value: true,
          label: '使用中'
        },
        {
          value: false,
          label: '未使用'
        }
      ],
      userOptions: [],
      companyId: 0,
      sortable: {},
      activeName: 0,
      activeCode: '',
      certificateFileUrl: '',
      callType: 'operation' // 'operation' 或 'pass'
    }
  },
  computed: {
    ...mapGetters(['addressDropOption', 'companyDrapdown']),
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    },
    fileds() {
      if (this.activeName) {
        return [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true
          },
          {
            filed: 'code',
            label: '代码',
            width: '80px'
          },
          // {
          //   filed: 'identityCode',
          //   label: '客户编码',
          //   width: '160px',
          //   fixed: 'left'
          // },
          {
            filed: 'nameCH',
            label: '中文名称',
            width: '180px',
            isCustom: true
          },
          {
            filed: 'nameEN',
            label: '英文名称',
            width: '180px'
          },
          {
            filed: 'wbName',
            label: '简称',
            width: '90px'
          },
          {
            filed: 'isActived',
            label: '状态',
            width: '100px',
            isCustom: true,
            isSort: true
          },
          {
            filed: 'noticeEmail',
            label: '预警邮箱',
            width: '160px'
          },
          {
            filed: 'yy',
            label: '营业执照',
            width: '80px',
            isCustom: true
          },
          {
            filed: 'address',
            label: '地址',
            width: '80px',
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            width: '80px',
            isCustom: true
          },
          {
            filed: 'saleName',
            label: '销售员',
            width: '80px'
          },
          {
            filed: 'legalMan',
            label: '法人',
            width: '80px'
          },
          {
            filed: 'currency',
            label: '结算币种',
            width: '80px'
          },
          {
            filed: 'bussinessFlag',
            label: '签订合同',
            width: '110px',
            formatter: (row) => {
              return row.bussinessFlag ? '是' : '否'
            },
            isSort: true
          },
          {
            filed: 'createdOn',
            label: '创建时间',
            width: '160px',
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : '',
            isSort: true
          },
          {
            filed: 'createdName',
            label: '创建人',
            width: '80px'
          },
          {
            filed: 'updatedOn',
            label: '更新时间',
            width: '160px',
            formatter: (row) =>
              row.updatedOn
                ? row.updatedOn.slice(0, row.updatedOn.length - 3)
                : '',
            isSort: true
          },
          {
            filed: 'updatedName',
            label: '更新人',
            width: '80px',
            isSort: true
          }
          // {
          //   filed: 'opt',
          //   label: '操作',
          //   width: '220px',
          //   fixed: 'right',
          //   isCustom: true
          // }
        ]
      } else {
        return [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'companyName',
            label: '公司名称',
            width: '400px',
            fixed: 'left'
          },
          {
            filed: 'yy',
            label: '营业执照',
            width: '100px',
            isCustom: true
          },
          {
            filed: 'applyTypeName',
            label: '申请方式',
            width: '120px'
          },
          {
            filed: 'createdOn',
            label: '申请时间',
            width: '180px',
            formatter: (row) =>
              row.createdOn
                ? row.createdOn.slice(0, row.createdOn.length - 3)
                : ''
          },
          {
            filed: 'createdName',
            label: '申请人',
            width: '120px',
            isSort: true
          },
          {
            filed: 'applyStatusName',
            label: '审核状态',
            width: '100px'
          }
        ]
      }
    }
  },
  beforeCreate: function() {
    that = this
  },
  created() {
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeList = ['DQR', 'YQR']
    const childrenCode = menu.children.map((a) => a.code)
    this.activeName = codeList.findIndex((a) => childrenCode.includes(a))
    this.activeCode = menu.children[0].code
    this.getCompanyList(this.pager)
    this.getUserList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }

    if (!this.addressDropOption || this.addressDropOption.length === 0) {
      this.$store.dispatch('getAddress')
    }
  },
  methods: {
    handleClick(i, code) {
      this.activeName = i
      this.activeCode = code
      this.initList()
    },
    initList() {
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getCompanyList(params)
    },
    getCompanyList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            ...this.formatterFilter()
          }
        }
        if (this.activeName !== 0) {
          getCompanyPages(params).then((res) => {
            if (res.success) {
              this.loading = false
              this.tableData1.total = res.data.total
              this.tableData1.columns = res.data.list
            } else {
              this.loading = false
              this.$message.error(res.errorMessage)
            }
          })
        } else {
          getApplyRecordPageList({
            ...params,
            queryParam: {
              ...params.queryParam,
              applyType: 0,
              applyStatus: 0
            }
          }).then((res) => {
            if (res.success) {
              this.loading = false
              this.tableData1.total = res.data.total
              this.tableData1.columns = res.data.list
            } else {
              this.loading = false
              this.$message.error(res.errorMessage)
            }
          })
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    getUserList() {
      getUserForType({}).then((res) => {
        if (res.success) {
          const arr = [
            // {
            //   value: 'ALL',
            //   label: '所有'
            // }
          ]
          res.data
            .filter((a) => [204, 210].indexOf(a.type) > -1)
            .map((item) => {
              arr.push({
                value: item.id,
                label: item.nameCH
              })
            })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    handlePageChange(pager) {
      this.pagerConfig = { ...pager }
      this.getCompanyList(pager)
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getCompanyList(this.pagerConfig)
    },
    approved(row) {
      this.editData = row
      this.dialogFormVisible = true
    },
    async refuse(row) {
      this.editData = row
      this.dialogFormVisible2 = true
    },
    async ok3({ refuseReason }) {
      this.dialogFormVisible2 = false
      try {
        const params = {
          // refuseReason,
          reason: refuseReason,
          companyApplyRecordId: this.editData.companyApplyRecordId
        }
        const res = await refuseCompany(params)
        if (res.success) {
          this.getCompanyList(this.pagerConfig)
          this.$message.success('拒绝成功')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    ok() {
      this.cancel()
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getCompanyList(params)
    },
    cancel() {
      this.dialogFormVisible = false
      this.callType = 'operation'
      this.editData = {}
    },
    changeStatus(value, row) {
      const obj = {
        id: row.id,
        isActived: !row.isActived
      }
      enableOrDisableCompany(obj).then((res) => {
        this.getCompanyList(this.pagerConfig)
        if (res.success) {
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    changeType(type) {
      this.activeName = type
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      const params = {
        pageIndex: 1,
        pageSize: this.pagerConfig.pageSize
      }
      this.reset()
      this.getCompanyList(params)
    },
    updateRow(row) {
      if (this.activeName) {
      this.callType = 'operation'
      } else {
      this.callType = 'pass'
      }
      this.editData = row
      this.dialogFormVisible = true
    },
    sendFilter() {
      if (
        this.filterList.search !== '' ||
        this.filterList.isActived !== '' ||
        this.filterList.areaValue !== '' ||
        this.filterList.saleId !== 'ALL' ||
        this.filterList.companyId !== ''
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.pagerConfig = {
        pageIndex: 1,
        pageSize: 20
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
        this.getCompanyList(params)
    },
    reset() {
      this.filterList = {
        search: '',
        isActived: '',
        areaValue: '',
        saleId: '',
        companyId: ''
      }
      this.isActive = false
    },
    formatterFilter() {
      return {
        search:
          this.filterList.search !== '' ? this.filterList.search : undefined,
        isActived:
          this.filterList.isActived !== ''
            ? this.filterList.isActived
            : undefined,
        areaValue:
          this.filterList.areaValue !== ''
            ? this.filterList.areaValue
            : undefined,
        saleId:
          this.filterList.saleId !== '' ? this.filterList.saleId : undefined,
        companyId:
          this.filterList.companyId !== ''
            ? this.filterList.companyId
            : undefined
      }
    },
    ok2() {
      this.cancel2()
    },
    cancel2() {
      this.editData = {}
      this.dialogFormVisible1 = false
    },
    billAccount(row) {
      this.editData = row
      this.dialogFormVisible1 = true
    },
    viewImg(row) {
      // const id = type ? row.certificateFileId : row.id
      this.certificateFileUrl = row.certificateFileUrl
      this.dialogVisible2 = true
    },
    async derive() {
      const params = {
        ...this.formatterFilter()
      }
      derive('company/exportCompany', 'post', params)
    },
    priceSet(row) {
      this.editData = row
      this.drawer = true
    },
    viewSub(row) {
      this.editData = row
      this.dialogVisible3 = true
    },
    viewMember(row) {
      this.editData = row
      this.dialogVisible4 = true
    }
  }
}
</script>

<style lang="less" scoped>
.imgbox {
  width: 810px;
  height: 540px;
  margin: auto;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tabItem {
    padding: 20px;
    width: 42px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
  }
  .activeName {
    color: rgb(18, 88, 188);
  }
  .opt {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .tabItem {
      padding: 20px;
      width: 42px;
      height: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
    }
    .activeName {
      color: rgb(18, 88, 188);
    }
  }
  .btn {
    width: 80px;
    height: 28px;
    background: #ffffff;
    color: rgb(18, 88, 188);
    border-radius: 4px;
    border: 1px solid rgb(18, 88, 188);
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .sub {
      padding:  0 8px;
      background: #DDEDF9;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      color: #076BAF;
    }
  }
  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
  .table-opt:deep(.el-button) {
    padding: 0;
  }
  .status {
    width: 28px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 20px;
    margin-left: 5px;
    margin-right: 20px;
  }
  .icon {
    font-size: 24px;
  }
  .license {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
</style>
